module.exports = __webpack_public_path__ + "static/media/tester-phone.148932e6.png";